import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileNav from './components/MobileNav';
import Home from './pages/Home';

// Outil Loader pendant le lazy loading
const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center" style={{ background: '#0a0a0c' }}>
    <div className="relative w-16 h-16">
      <div className="absolute top-0 left-0 w-full h-full border-4 border-[#00cec9]/20 rounded-full"></div>
      <div className="absolute top-0 left-0 w-full h-full border-4 border-[#6c5ce7] rounded-full border-t-transparent animate-spin"></div>
    </div>
  </div>
);

// Lazy Loaded Routes (Code Splitting pour le SEO / Vitesse)
const CityPage = lazy(() => import('./pages/CityPage'));
const Services = lazy(() => import('./pages/Services'));
const ServiceCreation = lazy(() => import('./pages/ServiceCreation'));
const ServiceRefonte = lazy(() => import('./pages/ServiceRefonte'));
const ServiceEcommerce = lazy(() => import('./pages/ServiceEcommerce'));
const ServiceWordPress = lazy(() => import('./pages/ServiceWordPress'));
const ServiceDesign = lazy(() => import('./pages/ServiceDesign'));
const ServiceMaintenance = lazy(() => import('./pages/ServiceMaintenance'));
const ServiceAutomatisationIA = lazy(() => import('./pages/ServiceAutomatisationIA'));

const MarketingSEOLocal = lazy(() => import('./pages/MarketingSEOLocal'));
const MarketingGoogleAds = lazy(() => import('./pages/MarketingGoogleAds'));
const MarketingSocialAds = lazy(() => import('./pages/MarketingSocialAds'));
const MarketingAudit = lazy(() => import('./pages/MarketingAudit'));
const MarketingHub = lazy(() => import('./pages/MarketingHub'));

const Agence = lazy(() => import('./pages/Agence'));
const Methodologie = lazy(() => import('./pages/Methodologie'));
const LandingNational = lazy(() => import('./pages/LandingNational'));
const Contact = lazy(() => import('./pages/Contact'));
const Simulateur = lazy(() => import('./pages/Simulateur'));

// BLOG (Lazy loaded)
const BlogHub = lazy(() => import('./pages/blog/BlogHub'));
const ArticleArtisan = lazy(() => import('./pages/blog/ArticleArtisan'));
const ArticlePrixSite = lazy(() => import('./pages/blog/ArticlePrixSite'));
const ArticleGoogleMaps = lazy(() => import('./pages/blog/ArticleGoogleMaps'));
const ArticleRefonteParis = lazy(() => import('./pages/blog/ArticleRefonteParis'));
const ArticleVitrineEcommerce = lazy(() => import('./pages/blog/ArticleVitrineEcommerce'));
const DynamicBlogPost = lazy(() => import('./pages/blog/DynamicBlogPost'));

// LEGAL (Lazy loaded)
const MentionsLegales = lazy(() => import('./pages/legal/MentionsLegales'));
const Confidentialite = lazy(() => import('./pages/legal/Confidentialite'));
const CGV = lazy(() => import('./pages/legal/CGV'));
const NotFound = lazy(() => import('./pages/NotFound'));
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App" style={{ background: '#0a0a0c', minHeight: '100vh' }}>
          <Header />
          <main className="pt-20">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/agence-web/:city" element={<CityPage />} />

                {/* Landing Pages */}
                <Route path="/lp/digital-france" element={<LandingNational />} />

                {/* Agence */}
                <Route path="/agence" element={<Agence />} />

                {/* Services */}
                <Route path="/services" element={<Services />} />
                <Route path="/services/creation" element={<ServiceCreation />} />
                <Route path="/services/refonte" element={<ServiceRefonte />} />
                <Route path="/services/ecommerce" element={<ServiceEcommerce />} />
                <Route path="/services/wordpress" element={<ServiceWordPress />} />
                <Route path="/services/design" element={<ServiceDesign />} />
                <Route path="/services/maintenance" element={<ServiceMaintenance />} />
                <Route path="/services/automatisation-ia" element={<ServiceAutomatisationIA />} />

                {/* Marketing */}
                <Route path="/marketing/seo-local" element={<MarketingSEOLocal />} />
                <Route path="/marketing/google-ads" element={<MarketingGoogleAds />} />
                <Route path="/marketing/social-ads" element={<MarketingSocialAds />} />
                <Route path="/marketing/audit" element={<MarketingAudit />} />

                {/* Blog */}
                <Route path="/blog" element={<BlogHub />} />
                <Route path="/blog/pourquoi-artisan-besoin-site-web" element={<ArticleArtisan />} />
                <Route path="/blog/prix-site-internet-yvelines" element={<ArticlePrixSite />} />
                <Route path="/blog/etre-premier-google-maps-commerce-local" element={<ArticleGoogleMaps />} />
                <Route path="/blog/refonte-site-web-paris-signes" element={<ArticleRefonteParis />} />
                <Route path="/blog/site-vitrine-vs-ecommerce-pme" element={<ArticleVitrineEcommerce />} />
                <Route path="/blog/:slug" element={<DynamicBlogPost />} />

                {/* Utility Pages */}
                <Route path="/contact" element={<Contact />} />
                <Route path="/simulateur" element={<Simulateur />} />

                {/* Pages légales */}
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/confidentialite" element={<Confidentialite />} />
                <Route path="/cgv" element={<CGV />} />

                {/* Pages désormais complètes */}
                <Route path="/marketing" element={<MarketingHub />} />
                <Route path="/methodologie" element={<Methodologie />} />

                {/* 404 — doit être en dernier */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <MobileNav />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
